exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message[data-v-5e4cf538]{text-align:left;padding:12px 16px;width:auto;max-width:-webkit-fill-available;word-wrap:break-word;border-radius:18px;font-size:95%;line-height:1.4;white-space:pre-wrap;-webkit-transition:.7s;transition:.7s;margin-bottom:8px}.my-box[data-v-5e4cf538]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-right:10px}.other-box[data-v-5e4cf538]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e4cf538","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BalloonParts/MessageViewParts.vue
// module id = eFI4
// module chunks = 0